export default __webpack_public_path__ + "static/media/looking.d6204a1f.svg";